import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertNotification = ({ alert, onDismiss, onInvestigate }) => {
  const getSeverityColor = () => {
    switch (alert?.severity) {
      case 'Kritisch': return 'bg-error/10 border-error text-error';
      case 'Warnung': return 'bg-warning/10 border-warning text-warning';
      case 'Info': return 'bg-primary/10 border-primary text-primary';
      default: return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getSeverityIcon = () => {
    switch (alert?.severity) {
      case 'Kritisch': return 'AlertCircle';
      case 'Warnung': return 'AlertTriangle';
      case 'Info': return 'Info';
      default: return 'Bell';
    }
  };

  return (
    <div className={`rounded-lg p-4 border-2 ${getSeverityColor()}`}>
      <div className="flex items-start gap-3">
        <Icon name={getSeverityIcon()} size={20} />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between mb-2">
            <h4 className="text-sm font-semibold">{alert?.title}</h4>
            <span className="text-xs opacity-70">{alert?.time}</span>
          </div>
          <p className="text-sm opacity-90 mb-3">{alert?.message}</p>
          <div className="flex items-center gap-2">
            <Button 
              variant="outline" 
              size="xs" 
              iconName="Search"
              onClick={() => onInvestigate(alert)}
            >
              Untersuchen
            </Button>
            <Button 
              variant="ghost" 
              size="xs" 
              iconName="X"
              onClick={() => onDismiss(alert)}
            >
              Schließen
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertNotification;